<template>
  <section class="section first_page">
    <div class="container-flud ">
      <loading-block v-if="is_load==false" :loading="!is_load"/>
      <div class="col-md-12 center-block d-flex justify-content-center loading_div " v-if="is_load==false">
        <h2>Идет загрузка...</h2>
      </div>
      <div class=""  v-if="is_load">
        <common-user-page :user="user" :activeTab="'services'" />
        <div class="container user_service_form mt-3">
        <div class="d-flex  col-12  justify-content-center mx-auto">
          <div class="     ">
            <div class="" v-if="service_show==false">
              <h2 class="text-center">{{ service.name }}</h2>

            </div>
            <div class="d-flex justify-content-center mx-auto" v-if="service_show==false">
              <button class="text-center btn mt-2 mb-2" @click="toogleService()"><i class="fa fa-caret-square-o-down" aria-hidden="true"></i> описание </button>
            </div>


            <div class="  row row-grid align-items-center"  v-if="service_show">

              <div class="col-12 d-flex justify-content-center img_div">

                <v-lazy-image  :src="image_url+service.image" class="p-4 img-fluid floating"/>
              </div>
              <div class="col-12 col-md-12 p-4 ">
                <h2 class="text-center">{{ service.name }}</h2>

                <div class="pr-md-5" >
                  <editorjsrender v-if="service.content_json && service.content_json.blocks" :align_style="'center'"  :blocks_json="service.content_json.blocks" ></editorjsrender>

                </div>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <button class="btn mt-2" @click="toogleService()"><i class="fa fa-caret-square-o-up" aria-hidden="true"></i> описание </button>
              </div>
            </div>

          </div>
        </div>

        <div class="mt-3">
          <h4 class="text-center">Форма заказа услуги</h4>
        </div>
        <div class="col-12 m-4 " ref="orderform">


          <editorjsinput v-if="!(service && service.isform=='1' && service.form_setting && service.form_setting.length>0)" :blocks_json="example_blocks" ref="editorjs" ></editorjsinput>

          <div class="d-flex justify-content-center mx-auto">
            <FormService ref="formService"  v-if="(service && service.isform=='1' && service.form_setting && service.form_setting.length>0)" :service="service"/>


          </div>
          <div class="d-flex justify-content-center mx-auto">
          <div class="alert alert-danger" v-if="iserror==true">
            <p>{{ error_message }}</p>
          </div>
          </div>

          <div class="d-flex justify-content-center mx-auto">
          <base-button  @click="onSave" v-if="!(service && service.isform=='1' && service.form_setting && service.form_setting.length>0)"  >Заказать услугу</base-button>
          <base-button  @click="onSaveForm" v-if="(service && service.isform=='1' && service.form_setting && service.form_setting.length>0)"  >Заказать услугу</base-button>
          </div>
        </div>




        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Vue from "vue";
import CommonUserPage from "@/components/user_page/CommonUserPage";
import Editorjsrender from "@/models/Editorjsrender";
import Editorjsinput from "@/models/Editorjsinput";
import FormService from "@/components/Custom/FormService";
import VLazyImage from "v-lazy-image/v2";

export default {
  name: "UserPageService",
  data(){
    return {
      "is_load":false,
      'iserror':false,
      'error_message':'',
      'user':null,
      'service':null,
      'image_url':null,
      'service_show':false,
    };
  },
  components: {LoadingBlock,CommonUserPage,Editorjsrender,Editorjsinput,FormService,VLazyImage},
  mounted: function () {
    var app=this;
    var id=this.$route.params.user_id;
    var service_id=this.$route.params.service_id;
    app.is_load=false;
    app.image_url = Vue.config.IMAGE_URL;
    app.loadMainData(id,service_id);
  },
  methods:{
    onSaveForm(){
      var app=this;
      var result_data=app.$refs.formService.saveForm();
      if(Object.entries(result_data).length>0){
        var newProject={};
        app.is_load=false;


        newProject.category=app.service.last_id;
        newProject.order_developer_id=app.user.last_id;
        newProject.form =result_data;
        Api.createProject(newProject, function (result) {
          app.is_load=true;
          if (result.iserror == false) {
            app.iserror = false;

            //document.location = "/project/" + result.project_id;
            app.$router.push({name: 'project', params: {id: result.project_id, "rand": Math.random()}});
          } else {
            app.iserror = true;
            app.error_message = result.error_message;
          }
        });
      }


    },
    onSave(){
      var app=this;
      app.is_load=false;
      app.$refs.editorjs.save(function(editor_js_data){

        var newProject={};
        newProject.category=app.service.last_id;
        newProject.order_developer_id=app.user.last_id;





        newProject.json = editor_js_data;
        Api.createProject(newProject, function (result) {
          app.is_load=true;
          if (result.iserror == false) {
            app.iserror = false;

            //document.location = "/project/" + result.project_id;
            app.$router.push({name: 'project', params: {id: result.project_id, "rand": Math.random()}});
          } else {
            app.iserror = true;
            app.error_message = result.error_message;
          }
        });




      });
    },
    toogleService(){
      var app=this;
      if(app.service_show==true){
        app.service_show=false;
      }else {
        app.service_show=true;
      }
    },
    scrollToElement() {

      const el = this.$refs.orderform;


      if (el) {



        // Use el.scrollIntoView() to instantly scroll to the element
        el[0].scrollIntoView({behavior: 'smooth'});
        this.isscrolling=true;
      }
    },

    loadMainData(id,service_id){
      var app=this;
      Api.loadUserPageService(id,service_id,function(data){
        app.user=data.user;
        app.service=data.service;
        app.is_load=true;
      },function(error){

        if(error.response.data.code==404){
          app.$router.push({name:'404'});
        }
      });
    }
  }
}
</script>

<style scoped>

</style>